import GroupAssignmentsForm from './GroupAssignmentsForm';

export default GroupAssignmentsForm;
